<template>
  <div id="legend-li" class="legend-li">
    <div class="item" v-for="(item,index) in lists.name">
      <div class="item-main">
        <div class="name">{{ item }}</div>
        <div class="rate">{{ lists.data[index].toFixed(1) }}<span class="dw">{{ dw }}</span></div>
      </div>
      <div class="ht-rate">
        <div class="item-ht">
          <span class="name">环比:</span>
          <!-- <span class="val red">{{ lists.rate.hb[index] }}%</span> -->
          <!-- <span class="val" :class="[lists.rate.hb[index]<0?'green':'red']">{{ percentage(lists.rate.hb[index]).toFixed(1) }}%</span> -->
          <span class="val" :class="[lists.rate.hb[index]<0?'green':'red']">{{ lists.rate.hb[index].toFixed(1) }}%</span>
        </div>
        <div class="item-ht flex-mla">
          <span class="name">同比:</span>
          <!-- <span class="val red">{{ lists.rate.tb[index] }}%</span> -->
          <!-- <span class="val" :class="[lists.rate.tb[index]<0?'green':'red']">{{ percentage(lists.rate.tb[index]).toFixed(1) }}%</span> -->
          <span class="val" :class="[lists.rate.tb[index]<0?'green':'red']">{{ lists.rate.tb[index].toFixed(1) }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common.js'

export default {
  mixins: [common],
  name: 'LegendLi',
  props: [
    'lists',
    'dw'
  ],
  data () {
    return {
      UserPaymentDistributionLists: [
        {
          name: '年',
          rate: '12000'
        }
      ]
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.legend-li
  color #000
  width 160px
  height 181px
  display: flex
  flex-direction: column
  justify-content: center
  .item
    width 100%
  .item+.item
    margin-top 10px
  .item-main
    display flex
    align-items center
  .name
    font-size: 14px
    color rgba(0, 0, 0, 0.8)
    white-space nowrap
    line-height: 20px
  .rate
    font-size: 20px
    color: #000
    margin-left: auto
    font-weight: bolder
    white-space nowrap
    .dw
      color: #878787;
      font-size: 6px
      margin-left: 6px
  .ht-rate
    display: flex
    line-height: 17px
    height: 17px
    width 100%
    .item-ht
      flex 0 0
      width 72px
      .name
        font-size 12px
        color: rgba(0, 0, 0, 0.6)
        white-space nowrap
      .val
        font-size 12px
        font-weight: bolder
        margin-left: 5px
        opacity 0.6
        &.red
          color red
        &.green
          color green
      &.flex-mla
        margin-left: auto
</style>
